module.exports = __webpack_public_path__ + "static_pc/img/infoTitle.111e87f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/infoTitle.png
// module id = cHHt
// module chunks = 1